import { Skeleton } from "@components/ui/skeleton"

type TSkeletonConfig = {
  count: number
  height: string
}

export const renderSkeletonGroups = (configs: TSkeletonConfig[]) =>
  configs.flatMap(({ count, height }) =>
    Array.from({ length: count }).map((_, i) => (
      <Skeleton key={`${height}-${i}`} className={`${height} tw:rounded-sm`} />
    ))
  )
